export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? ''
export const WEB_BASE_URL = import.meta.env.VITE_WEB_BASE_URL ?? ''
export const MOCK_BASE_DOMAIN = import.meta.env.VITE_MOCK_BASE_DOMAIN ?? 'lvh.me:3000'
export const MOCK_BASE_SCHEME = import.meta.env.VITE_MOCK_BASE_SCHEME ?? 'http'
